import React from 'react';
import { motion } from 'framer-motion';
import { FolderOpen, MousePointerClick, Heart, ArrowRight } from 'lucide-react';
const steps = [{
  n: 1,
  Icon: FolderOpen,
  title: 'Abrís el material',
  desc: 'Todo organizado por temáticas. Encontrás rápido lo que necesitás.'
}, {
  n: 2,
  Icon: MousePointerClick,
  title: 'Elegís la clase o secuencia',
  desc: 'Cada clase ya viene preparada, con objetivos y variantes.'
}, {
  n: 3,
  Icon: Heart,
  title: 'La aplicás con tus alumnos',
  desc: 'Sin perder horas planificando. Listo para guiar.'
}];
export function Solution() {
  return <section className="py-24 lg:py-32 bg-brand-900 text-white relative overflow-hidden" data-id="element-195">
      <div className="absolute -top-40 -right-40 w-[500px] h-[500px] bg-brand-700/30 rounded-full blur-3xl pointer-events-none" data-id="element-196"></div>
      <div className="absolute -bottom-40 -left-40 w-[500px] h-[500px] bg-brand-800/40 rounded-full blur-3xl pointer-events-none" data-id="element-197"></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-198">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-20 max-w-3xl mx-auto" data-id="element-199">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-brand-800/50 text-accent-300 font-medium text-xs uppercase tracking-widest mb-6 border border-brand-700/50" data-id="element-200">
            La solución
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-medium mb-6 leading-tight tracking-tight" data-id="element-201">
            Por eso creamos{' '}
            <span className="text-accent-400 italic" data-id="element-202">
              Mega Pack Yoga Listo 2026
            </span>
          </h2>
          <p className="text-lg text-brand-100 font-light" data-id="element-203">
            Un sistema completo para resolver todo tu año.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 relative" data-id="element-204">
          {/* Connector line desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-px border-t border-dashed border-brand-700/50 z-0" data-id="element-205"></div>

          {steps.map((step, i) => {
          const Icon = step.Icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.15
          }} className="relative bg-brand-800/40 backdrop-blur-sm rounded-[2rem] p-8 lg:p-10 border border-brand-700/30 z-10" data-id="element-206">
                {/* Number badge */}
                <div className="w-12 h-12 rounded-full bg-accent-400 text-brand-900 font-serif font-medium text-xl flex items-center justify-center mb-8 shadow-sm" data-id="element-207">
                  {step.n}
                </div>
                <div className="w-12 h-12 rounded-full bg-brand-900/50 text-accent-300 flex items-center justify-center mb-6 border border-brand-700/50" data-id="element-208">
                  <Icon className="w-5 h-5" strokeWidth={1.5} data-id="element-209" />
                </div>
                <h3 className="font-serif font-medium text-2xl mb-4 leading-tight text-white" data-id="element-210">
                  {step.title}
                </h3>
                <p className="text-brand-100/80 leading-relaxed font-light" data-id="element-211">
                  {step.desc}
                </p>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center mt-16" data-id="element-212">
          <p className="text-brand-200 inline-flex items-center gap-3 text-lg font-light" data-id="element-213">
            Así de simple. <ArrowRight className="w-5 h-5 text-accent-400" data-id="element-214" />
            <span className="font-medium text-white" data-id="element-215">
              Sin improvisar. Sin perder horas planificando.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}